import { actions } from 'src/constants';

const initialState = {
  data: [],
  hasLoaded: false,
  isLoading: false,
  isSubmitting: false,
};

const actionMap = {
  [actions.NOTES_GET_REQUEST]: (state) => ({
    ...state,
    hasLoaded: false,
    isLoading: true,
  }),
  [actions.NOTES_GET_SUCCESS]: (state, { result }) => ({
    ...state,
    data: result.data,
    hasLoaded: true,
    isLoading: false,
  }),
  [actions.NOTES_GET_FAILURE]: (state) => ({
    ...state,
    hasLoaded: false,
    isLoading: false,
  }),

  [actions.ADD_NOTE_TO_STUDENT_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
  }),
  [actions.ADD_NOTE_TO_STUDENT_SUCCESS]: (state) => ({
    ...state,
    isSubmitting: false,
  }),
  [actions.ADD_NOTE_TO_STUDENT_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
  }),
};

export default (state = initialState, action) => {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }

  return state;
};
